<div
  class="w-full
    min-h-[100dvh]
    grid
    grid-cols-1
    lg:grid-cols-2
    bg-[#fffcf9]
    overflow-x-hidden"
>

  <!-- ========================================================= -->
  <!-- DESKTOP IMAGE PANEL -->
  <!-- ========================================================= -->

  <section class="auth-hero hidden lg:block" aria-label="CircledPlus private marketplace">
    <img class="auth-hero-image" src="assets/img/Circled_Plus_Login.webp"
         alt="Luxury apartment in Bengaluru" width="720" height="1080" />
    <div class="auth-hero-shade" aria-hidden="true"></div>
    <div class="auth-hero-copy">
      <span class="auth-hero-label">Circled+ Private Marketplace</span>
      <p class="auth-hero-kicker">Private Member Access</p>
      <h1>Discover Bengaluru’s<br>finest homes.</h1>
      <p>Curated properties, private access and smarter decisions for discerning home buyers.</p>
    </div>
  </section>


  <!-- ========================================================= -->
  <!-- SIGNUP PANEL -->
  <!-- ========================================================= -->

  <main
    class="w-full
      min-h-[100dvh]
      bg-[#fffcf9]"
  >


    <div
      class="w-full
             min-h-[100dvh]
             flex flex-col
             items-center
             px-5
             py-7
             sm:px-8
             sm:py-10
             lg:px-12
             xl:px-16
             lg:justify-center"
    >

      <div
        class="w-full
               max-w-[430px]
               lg:max-w-[520px]"
      >


        <!-- =================================================== -->
        <!-- LOGO -->
        <!-- =================================================== -->

        <div
          class="flex
                 justify-center
                 mb-7"
        >

          <a routerLink="/" class="auth-logo-link" aria-label="CircledPlus home">

            <img
              src="/cir-home/images/circledplus-logo.svg"
              alt="CircledPlus"
              class="auth-logo"
            width="156" height="40" />

          </a>

        </div>


        <!-- =================================================== -->
        <!-- HEADING -->
        <!-- =================================================== -->

        <div
          class="text-center
                 mb-7"
        >

          <h2
            class="font-bold
                   leading-tight
                   mb-3"
            style="
              font-family:'Georgia','Times New Roman',serif;
              font-size:2.2rem;
              color:#242126;
              letter-spacing:-0.5px;
            "
          >
            Create your account
          </h2>


          <p
            class="text-[15px]
                   sm:text-base
                   leading-6"
            style="color:#706971;"
          >
            Join Circled+ and discover homes curated
            exclusively for you
          </p>

        </div>


        <!-- =================================================== -->
        <!-- ACCESS MESSAGE -->
        <!-- =================================================== -->

        <div class="mb-7">

          <div
            class="flex
                   items-center
                   gap-3
                   w-full
                   rounded-xl
                   px-4
                   sm:px-5
                   py-4"
            style="
              background:#f7f3fc;
              border:1.5px solid #8c52ff;
            "
          >

            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              class="shrink-0"
              aria-hidden="true"
            >

              <path
                d="M12 2L2 9l10 13L22 9 12 2z"
                stroke="#8c52ff"
                stroke-width="1.8"
                stroke-linejoin="round"
              />

              <path
                d="M2 9h20M12 2l-5 7M12 2l5 7"
                stroke="#8c52ff"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

            </svg>


            <span
              class="text-sm
                     font-semibold
                     leading-5"
              style="color:#8c52ff;"
            >
              Complimentary access to 3 curated luxury homes
            </span>

          </div>

        </div>


        <!-- =================================================== -->
        <!-- SIGNUP FORM -->
        <!-- =================================================== -->

        <form
          [formGroup]="signupForm"
          class="w-full space-y-5"
          (ngSubmit)="signupForm.valid && signUser()"
        >


          <!-- ================================================= -->
          <!-- FULL NAME -->
          <!-- ================================================= -->

          <div>

            <label
              for="signup-name"
              class="block
                     text-sm
                     font-semibold
                     mb-2"
              style="color:#242126;"
            >
              Full Name
            </label>


            <input
              id="signup-name"
              type="text"
              placeholder="Enter your full name"
              formControlName="name"
              autocomplete="name"
              class="
                block
                w-full
                h-14
                px-4
                rounded-xl
                text-[16px]
                transition-all
                duration-200
              "
              style="
                background:#ffffff;
                border:1.5px solid #e7e1dc;
                color:#242126;
                outline:none;
                -webkit-appearance:none;
                appearance:none;
                box-sizing:border-box;
              "
            />

          </div>


          <!-- ================================================= -->
          <!-- EMAIL -->
          <!-- ================================================= -->

          <div>

            <label
              for="signup-email"
              class="block
                     text-sm
                     font-semibold
                     mb-2"
              style="color:#242126;"
            >
              Email address
            </label>


            <input
              id="signup-email"
              type="email"
              placeholder="name@domain.com"
              formControlName="email"
              autocomplete="email"
              class="
                block
                w-full
                h-14
                px-4
                rounded-xl
                text-[16px]
                transition-all
                duration-200
              "
              style="
                background:#ffffff;
                border:1.5px solid #e7e1dc;
                color:#242126;
                outline:none;
                -webkit-appearance:none;
                appearance:none;
                box-sizing:border-box;
              "
            />

          </div>


          <!-- ================================================= -->
          <!-- PHONE -->
          <!-- ================================================= -->

          <div>

            <label
              for="signup-phone"
              class="block
                     text-sm
                     font-semibold
                     mb-2"
              style="color:#242126;"
            >
              Contact number
            </label>


            <!-- Phone wrapper -->

            <div
              class="
                relative
                flex
                items-center
                w-full
                rounded-xl
              "
              style="
                background:#ffffff;
                border:1.5px solid #e7e1dc;
                box-sizing:border-box;
              "
            >

              <!-- ============================================= -->
              <!-- COUNTRY SELECTOR -->
              <!-- ============================================= -->

              <div
                class="relative shrink-0"
              >

                <button
                  type="button"
                  (click)="toggleDropdown()"
                  class="
                    flex
                    items-center
                    gap-1.5
                    h-14
                    px-3
                    rounded-l-xl
                    text-sm
                    font-medium
                    whitespace-nowrap
                  "
                  style="
                    background:transparent;
                    color:#706971;
                    cursor:pointer;
                    border-right:1px solid #e7e1dc;
                  "
                >

                  <span
                    class="text-lg leading-none"
                  >
                    {{ selectedCountry?.flag }}
                  </span>


                  <span>
                    {{ selectedCountry?.dial }}
                  </span>


                  <span
                    class="text-xs ml-1"
                    style="color:#827a83;"
                  >
                    {{ dropdownOpen ? '▲' : '▼' }}
                  </span>

                </button>


                <!-- =========================================== -->
                <!-- COUNTRY DROPDOWN -->
                <!-- =========================================== -->

                <div
                  *ngIf="dropdownOpen"
                  class="
                    absolute
                    top-full
                    left-0
                    mt-2
                    z-[100]
                    w-[min(288px,calc(100vw-40px))]
                    rounded-xl
                    flex
                    flex-col
                    overflow-hidden
                  "
                  style="
                    background:#ffffff;
                    border:1px solid #e7e1dc;
                    box-shadow:0 12px 40px rgba(0,0,0,0.14);
                  "
                >

                  <!-- Search -->

                  <div
                    class="p-2 shrink-0"
                    style="border-bottom:1px solid #f0e8fc;"
                  >

                    <input
                      type="text"
                      [(ngModel)]="searchQuery"
                      [ngModelOptions]="{standalone:true}"
                      placeholder="Search country..."
                      class="
                        w-full
                        h-11
                        rounded-lg
                        px-3
                        text-[16px]
                        outline-none
                      "
                      style="
                        border:1px solid #e7e1dc;
                        color:#242126;
                        box-sizing:border-box;
                      "
                    />

                  </div>


                  <!-- Country list -->

                  <ul
                    class="
                      overflow-y-auto
                      max-h-60
                      overscroll-contain
                      flex-1
                    "
                    style="-webkit-overflow-scrolling:touch;"
                  >

                    <li
                      *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)"
                      class="
                        flex
                        items-center
                        gap-2.5
                        px-3
                        py-2.5
                        cursor-pointer
                        text-sm
                      "
                      [style.background]="
                        country.code === selectedCountry.code
                          ? '#f7f3fc'
                          : ''
                      "
                    >

                      <span
                        class="
                          text-lg
                          w-6
                          text-center
                          shrink-0
                        "
                      >
                        {{ country?.flag }}
                      </span>


                      <span
                        class="flex-1 truncate"
                        style="color:#242126;"
                      >
                        {{ country?.name }}
                      </span>


                      <span
                        class="font-medium text-xs shrink-0"
                        style="color:#827a83;"
                      >
                        {{ country?.dial }}
                      </span>

                    </li>

                  </ul>

                </div>

              </div>


              <!-- ============================================= -->
              <!-- PHONE INPUT -->
              <!-- ============================================= -->

              <input
                id="signup-phone"
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                placeholder="Enter your contact number"
                formControlName="phone"
                class="
                  flex-1
                  min-w-0
                  h-14
                  px-4
                  rounded-r-xl
                  text-[16px]
                  outline-none
                "
                style="
                  background:transparent;
                  color:#242126;
                  border:0;
                  box-sizing:border-box;
                  -webkit-appearance:none;
                  appearance:none;
                "
              />

            </div>


            <p
              class="mt-1.5 text-xs"
              style="color:#827a83;"
            >
              We'll use this number to verify your account.
            </p>

          </div>


          <!-- ================================================= -->
          <!-- CREATE ACCOUNT -->
          <!-- ================================================= -->

          <button
            type="submit"
            class="
              flex
              w-full
              h-14
              justify-center
              items-center
              gap-2.5
              rounded-full
              text-base
              font-semibold
              transition-all
              duration-200
            "
            style="
              background:#8c52ff;
              color:#ffffff;
              letter-spacing:0.01em;
            "
          >

            Create Account

            <span
              aria-hidden="true"
              style="
                font-size:1.1rem;
                line-height:1;
              "
            >
              →
            </span>

          </button>

        </form>


        <!-- =================================================== -->
        <!-- TRUST CARD -->
        <!-- =================================================== -->

        <div class="mt-7">

          <div
            class="rounded-xl p-4"
            style="
              background:#ffffff;
              border:1.5px solid #f0e8fc;
            "
          >

            <div class="flex items-center gap-3">

              <!-- Icon -->

              <div
                class="
                  flex
                  items-center
                  justify-center
                  w-11
                  h-11
                  rounded-full
                  shrink-0
                "
                style="background:#f0e8fc;"
              >

                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >

                  <path
                    d="M12 2L4 5.5v5c0 4.5 3.2 8.7 8 10
                       4.8-1.3 8-5.5 8-10v-5L12 2z"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linejoin="round"
                  />

                  <rect
                    x="9"
                    y="10"
                    width="6"
                    height="5"
                    rx="1"
                    stroke="#8c52ff"
                    stroke-width="1.4"
                  />

                  <path
                    d="M10 10V8.8a2 2 0 014 0V10"
                    stroke="#8c52ff"
                    stroke-width="1.4"
                    stroke-linecap="round"
                  />

                </svg>

              </div>


              <!-- Text -->

              <div class="min-w-0">

                <p
                  class="font-bold text-sm"
                  style="color:#242126;"
                >
                  Your details stay private
                </p>


                <p
                  class="
                    text-xs
                    mt-1
                    leading-relaxed
                  "
                  style="color:#706971;"
                >
                  Your information is only used to create
                  and secure your Circled+ account.
                </p>

              </div>

            </div>

          </div>

        </div>


        <!-- =================================================== -->
        <!-- LOGIN LINK -->
        <!-- =================================================== -->

        <div
          class="mt-7
                 text-center"
        >

          <p
            class="text-sm"
            style="color:#706971;"
          >

            Already have an account?

            <a
              class="
                font-semibold
                cursor-pointer
                hover:underline
              "
              style="color:#242126;"
              [routerLink]="['/login']"
              [queryParamsHandling]="'preserve'"
            >
              Login
            </a>

          </p>

        </div>


        <!-- =================================================== -->
        <!-- LEGAL FOOTER -->
        <!-- =================================================== -->

        <div
          class="mt-5 pt-4"
          style="border-top:1px solid #e7e1dc;"
        >

          <p
            class="
              text-center
              text-xs
              leading-relaxed
            "
            style="color:#706971;"
          >

            By creating an account, you agree to our

            <a
              [routerLink]="['/termsandcondition']"
              class="
                font-bold
                hover:underline
              "
              style="color:#242126;"
            >
              Terms &amp; Conditions
            </a>

            and

            <a
              [routerLink]="['/privacypolicy']"
              class="
                font-bold
                hover:underline
              "
              style="color:#242126;"
            >
              Privacy Policy
            </a>

          </p>

        </div>


      </div>

    </div>

  </main>

</div>